export default __webpack_public_path__ + "1b17b1643b58c21b9270fe6d8a762464.svg";